/* eslint-disable no-unused-vars */
import { defaultClient as ApolloClient } from "../main";
import {
  ADD_ATTENDANCE,
  GET_ATTENDANCE_LIST,
  GET_ACTIVITY,
  GET_RECORDS_LIST,
  GET_NEW_TOKEN,
  GET_PROGRAM,
  UPLOAD_FILES
} from "../components/constants/graphql";

export default {
  // eslint-disable-next-line
  allAttendance: ({ commit }, payload) => {
    commit("setLoading", true);
    //use ApolloClient to fire graphql query
    ApolloClient.query({
      query: GET_ATTENDANCE_LIST
    })
      .then(({ data }) => {
        //Get data from actions to state via mutations
        // commmit passes data from actions along to mutation function
        commit("setAttendanceList", data.allAttendance);
        commit("setLoading", false);
      })
      .catch(err => {
        commit("setLoading", false);
        console.error(err);
      });
  },
  allActivity: async ({ commit }) => {
    commit("setLoading", true);
    return ApolloClient.query({
      query: GET_ACTIVITY
    })
      .then(({ data }) => {
        commit("setActivity", data.allActivity);
        commit("setLoading", false);
      })
      .catch(err => {
        commit("setLoading", false);
        console.error(err);
      });
  },
  // eslint-disable-next-line
  addAttendance: ({ commit }, payload) => {
    ApolloClient.mutate({
      mutation: ADD_ATTENDANCE,
      variables: payload
    })
      // eslint-disable-next-line
      .then(({ data }) => {})
      .catch(err => {
        console.error(err);
      });
  },

  allRecordsList: async ({ commit }, payload) => {
    commit("setLoading", true);
    return ApolloClient.query({
      query: GET_RECORDS_LIST,
      variables: payload
    })
      .then(({ data }) => {
        commit("setRecordsList", data.recordsList);
        commit("setLoading", false);
      })
      .catch(err => {
        commit("setLoading", false);
        console.error(err);
      });
  },
  // addNewRank: async ({ dispatch }, payload) => {
  //   return ApolloClient.mutation({
  //     mutation:
  //   })
  // },

  getNewToken: ({ commit }, payload) => {
    // remove token in localStorage
    commit("clearError");
    localStorage.setItem("graphqlError", "");
    commit("setLoading", true);
    ApolloClient.mutate({
      mutation: GET_NEW_TOKEN,
      variables: payload,
      update: (client, { data: { getNewToken } }) => {} // eslint-disable-line
    })
      .then(({ data }) => {
        // Add user data to state
        //commit('setUser', data.getCurrentUser);
        localStorage.setItem("token", data.getNewAccessToken.newAccessToken);
        localStorage.setItem("graphqlError", "");
        commit("setLoading", false);
      })
      .catch(err => {
        //commit('setUser', null);
        //localStorage.setItem('userId','');
        commit("setLoading", false);
        commit("setError", err);
        console.error(err);
      });
  },

  uploadFiles: ({ commit }, payload) => {
    //commit("clearError");
    commit("setLoading", true);
    // clear token to prevent any errors if malformed.

    //var payload_var= payload.file;

    //const formData = new FormData();

    //formData.append("file",payload);

    ApolloClient.mutate({
      mutation: UPLOAD_FILES,
      variables: {
        file: payload.file
      }
      //update: (client, { data: { uploadFiles } }) => {}
    })
      .then(() => {
        commit("setLoading", false);
      })
      .catch(err => {
        commit("setLoading", false);
        commit("setError", err);
        console.error(err);
      });
  }
};
